<h2 mat-dialog-title class="notification-dialog-title">Notifikationer</h2>

<mat-dialog-content class="notification-dialog-content">
    <p class="notification-description">Få besked når der er nye dokumenter til dig i E|Forsyning.</p>

    <hr class="notification-divider" />

    <section class="document-notifications" aria-label="Dokument-notifikationer">
        <div class="document-notifications__icon">
            <mat-icon>description</mat-icon>
        </div>

        <div class="document-notifications__content">
            <h3>Dokument-notifikationer</h3>
            <p>Modtag notifikationer ved nye dokumenter.</p>
        </div>

        <div class="document-notifications__actions">
            <mat-slide-toggle [checked]="isNotificationEnabled" [disabled]="isLoading" (change)="onToggleChange($event.checked)"></mat-slide-toggle>
            @if (isLoading) {
                <mat-spinner diameter="18"></mat-spinner>
            }
        </div>
    </section>

    <div class="notification-state" [class.notification-state--enabled]="isNotificationEnabled">
        <span class="notification-state__dot" [class.notification-state__dot--enabled]="isNotificationEnabled" aria-hidden="true"></span>
        <div>
            <p class="notification-state__title">{{ isNotificationEnabled ? "Aktiveret" : "Deaktiveret" }}</p>
            <p class="notification-state__text">
                {{ isNotificationEnabled ? "Du modtager notifikationer ved nye dokumenter." : "Du modtager ikke notifikationer ved nye dokumenter." }}
            </p>
        </div>
    </div>

    <hr class="notification-divider" />

    @if (!isNotificationPermissionGranted) {
        <section class="notification-info" aria-label="Information om notifikationer">
            <mat-icon>info</mat-icon>
            <div>
                <p class="notification-info__title">Fravalgt notifikationer tidligere?</p>
                <p class="notification-info__text">
                    <span> Du kan genaktivere notifikationer ved at klikke </span>
                    <a href="javascript:void(0)" (click)="requestPermissionsFromDevice()">her.</a>
                </p>
                <br />
                <p class="notification-enable-guide__heading">Du kan også ændre dette i din telefons indstillinger:</p>
                <em> Indstillinger > Apps > E|Forsyning > Notifikationer > Tillad notifikationer </em>
            </div>
        </section>
    }

    <eforsyning-notification-permission-request></eforsyning-notification-permission-request>
</mat-dialog-content>

<mat-dialog-actions align="end" class="notification-dialog-actions">
    <button mat-stroked-button type="button" (click)="closeDialog()">Luk</button>
</mat-dialog-actions>
